import { I18n } from "@assets/strings";
import React from "react";
import { Group } from "@domain/group/group";
import { useSuggestedGroups } from "@domain/group/hooks";
import { Carousel } from "@ui/components/carousel/carousel";
import { ShareroomThumbnailSmall } from "@ui/components/group/shareroomThumbnailSmall";

type FeedShareroomSuggestionsProps = React.HTMLAttributes<HTMLDivElement>;
export const FeedShareroomSuggestions: React.FC<FeedShareroomSuggestionsProps> = ({ ...htmlProps }) => {
	const { result, loading } = useSuggestedGroups(5, "SHAREROOM");
	const suggestedOpenDiscussions = result.filter((suggestion) => suggestion.accessMode === "ADMIN_CONSENT");

	return suggestedOpenDiscussions.length > 0 ? (
		<Carousel
			{...htmlProps}
			title={I18n.t("feed.suggestions.sharerooms")}
			items={suggestedOpenDiscussions}
			renderItem={(shareroom) => <ShareroomThumbnailSmall key={shareroom.id} shareroom={shareroom as Group} />}
			loading={loading}
		/>
	) : null;
};
